<template>
  <div>
    <!-- <div class="loading-container" v-show="showLoading">
      <van-loading size="32px" vertical color="#0094ff" class="loading">正在获取健康码信息...</van-loading>
    </div> -->
    <!-- 粤康码，穗康码信息展示 -->
    <van-dialog v-model="showHealthInfo" confirm-button-text="确认" @close="onDialogClose">
      <!-- 粤康码/穗康码信息 -->
      <div class="health-container">
        <div style="padding: 0.7rem 0.5rem;" v-for="(healthInfo, index) in healthInfoList" :key="index"
          :style="healthInfoStyle(healthInfo, index, healthInfoList.length)">
          <div class="flex text-left">
            <div class="w60">
              <p style="padding-bottom: 0.25rem;">粤康码/穗康码信息</p>
              <p>身份证号：<span>{{ healthInfo.CustCertNo }}</span></p>
              <p style="margin-top: 0.25rem;">姓名：<span>{{ healthInfo.CustName }}</span></p>
            </div>
            <div class="w40 text-center">
              <div style="margin-top: 0.1rem;">
                <span class="iconfont iconerweima" :style="getHealthCodeStyle(healthInfo.hColor)"
                  style="font-size: 3rem;"></span>
                <div class="text-center">{{ getHealthCodeText(healthInfo.hColor) }}</div>
              </div>
            </div>
          </div>
          <div class="bg-white hesuan" :style="getHesuanBackColor(healthInfo.hsTestTime)"
            v-if="healthInfo.hsResult == '阴性'">
            <div class="hesuanBorder" :style="getHesuanBorderStyle(healthInfo.hsTestTime)">
              <p class="">
                核酸检测
              </p>
              <div>
                <div class="flex flex-justify-center flex-items-center">
                  <div class="bold6" style="font-size: 1.5rem; margin-right: 0.2rem;">
                    <span>{{ getHesuanHour(healthInfo.hsTestTime) }}</span>
                  </div>
                  <div class="flex flex-column text-left">
                    <span>{{ getHesuanUnit(healthInfo.hsTestTime) }}</span>
                    <span :style="getHesuanResulStyle(healthInfo.hsTestTime)">{{ healthInfo.hsResult }}</span>
                  </div>
                </div>
              </div>
              <p class="text-center">{{healthInfo.hsTestTime}}</p>
            </div>
          </div>
          <div v-if="!healthInfo.hsResult">
            <p class="text-center text-bold" style="margin-top: 0.5rem; color: #d81e06;">未查询到近期核酸检测记录</p>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getHealthInfoByIdCard } from "@/js/frameworkUtils";
export default {
  name: 'health-info',
  props: {
    // 是否保存健康信息
    isSaveHealthInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showHealthInfo: false,
      // healthInfo: {} // 粤康码/穗康码信息
      healthInfoList: [], // 粤康码/穗康码信息
      showLoading: false
    }
  },
  mounted() {
    this.$on('show', this.onShowHealthInfo)
  },
  computed: {
    /**
     * 健康码颜色
     */
    getHealthCodeStyle() {
      return function (hColor) {
        var val = '';
        switch (hColor) {
          case '0':
            val = '#56b292';
            break;
          case '1':
            val = '#f4ea2f';
            break;
          case '2':
            val = '#d81e06';
            break;
        }
        return {
          'color': val
        };
      }
    },
    /**
     * 健康码文本
     */
    getHealthCodeText() {
      return function (hColor) {
        var val = '绿码';
        switch (hColor) {
          case '0':
            val = '绿码';
            break;
          case '1':
            val = '黄码';
            break;
          case '2':
            val = '红码';
            break;
        }
        return val;
      }
    },
    /**
     * 核酸检测时间计算
     */
    getHesuanHour() {
      return function (hsTestTime) {
        let now = this.$moment(new Date());
        let hsTestDate = this.$moment(hsTestTime);
        let diffHours = now.diff(hsTestDate, 'hours', true);
        let val = '';
        if (diffHours <= 24) {
          val = '24';
        }
        else if (diffHours <= 48) {
          val = '48';
        }
        else if (diffHours <= 72) {
          val = '72';
        }
        else if (diffHours <= 168) {
          val = '7';
        }
        return val;
      }
    },
    /**
     * 核酸检测单位计算
     */
    getHesuanUnit() {
      return function (hsTestTime) {
        let hsHour = this.getHesuanHour(hsTestTime);
        let val = '';
        switch (hsHour) {
          case '24':
          case '48':
          case '72':
            val = '小时';
            break;
          case '7':
            val = '天';
            break;
          default:
            break;
        }
        return val;
      }
    },
    /**
     * 核酸检测结果字体样式计算
     */
    getHesuanResulStyle() {
      return function (hsTestTime) {
        let hsHour = this.getHesuanHour(hsTestTime);
        let val = {
          'color': 'white'
        };
        if (hsHour == '') {
          val = {
            'color': '#48bf8d',
            'font-weight': 'bold',
            'padding': '0.35rem 0',
            'font-size': '0.7rem'
          }
        }
        return val;
      }
    },
    /**
     * 核酸检测背景色
     */
    getHesuanBackColor() {
      return function (hsTestTime) {
        let hsHour = this.getHesuanHour(hsTestTime);
        let val = {
          'background-image': ''
        };
        switch (hsHour) {
          case '24':
            val['background-image'] = 'linear-gradient(#3f88ee, #1736bf)';
            break;
          case '48':
            val['background-image'] = 'linear-gradient(#aa8ded, #7b5ccb)';
            break;
          case '72':
            val['background-image'] = 'linear-gradient(#45b345, #38812c)';
            break;
          case '7':
            val['background-image'] = 'linear-gradient(#0ba8b0, #006265)';
            break;
          default:
            val = {
              'background': '#aaa'
            };
            break;
        }
        return val;
      }
    },
    /**
     * 核酸检测边框样式
     */
    getHesuanBorderStyle() {
      return function (hsTestTime) {
        let hsHour = this.getHesuanHour(hsTestTime);
        let val = {};
        if (hsHour == '') {
          val = {
            'color': 'black',
            'background': '#fff'
          }
        }
        return val;
      }
    },
    /**
     * 获取登录用户
     */
    getSysUser() {
      return JSON.parse(window.localStorage.getItem('adminInfo'))
    },
    /**
     * 健康码信息样式
     */
    healthInfoStyle() {
      return (healthInfo, index, length) => {
        let style = {};
        // 最后一个不显示分隔线条
        if (index != length - 1) {
          style['border-bottom'] = '1px solid #666';
        }
        return style;
      }
    }
  },
  methods: {
    onShowHealthInfo(ticketList) {
      // 展示粤康码/穗康码（仅在APP环境下）
      if (window.framework) {
        this.healthInfoList = []; // 清空原有信息
        let timeout = 700; // 延时毫秒数
        // this.showLoading = true; // 展示加载动画
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        ticketList.forEach(async (ticket, index) => {
          // alert('票明细：' + JSON.stringify(ticket) + '，延时毫秒：'.concat(timeout * index));
          setTimeout(() => {
            getHealthInfoByIdCard(ticket.CustCertNo, ticket.CustName).then(obj => {
              // alert('票明细：' + JSON.stringify(ticket))
              let healthInfo = obj.data;
              healthInfo.CustCertNo = ticket.CustCertNo;
              healthInfo.CustName = ticket.CustName;
              // alert('获取粤康码信息成功：' + JSON.stringify(healthInfo))
              // this.healthInfo.hColor = 1;
              this.healthInfoList.push(healthInfo);
              if (this.healthInfoList.length == ticketList.length) {
                this.showHealthInfo = true;
                this.$toast.clear();
                // this.showLoading = false; // 隐藏加载动画
              }

              // 保存健康码信息
              if (this.isSaveHealthInfo) {
                let sysUser = this.getSysUser;
                let params = {
                  _JsonText: JSON.stringify({
                    TikcetOrderDetailGID: ticket.OrderDetailGID,
                    ResponseMsg: JSON.stringify(healthInfo),
                    HealthColor: this.getHealthCodeText(healthInfo.hColor),
                    HeSuanResult: this.getHesuanHour(healthInfo.hsTestTime) + this.getHesuanUnit(healthInfo.hsTestTime) + healthInfo.hsResult,
                    ModifyGID: sysUser.GID,
                    ModifyCode: sysUser.UserCode,
                    ModifyName: sysUser.UserName
                  })
                }
                this.$http.post(this.$api.HealthInfoSave, params)
                  .then(res => { })
                  .catch(err => { });
              }
            }).catch((err) => {
              alert('获取粤康码信息失败：' + err)
            })
          }, timeout * index);
        });
      }
    },
    /**
     * 弹窗关闭事件回调
     * @param {*} e 
     */
    onDialogClose(e) {
      // 回调父组件关闭健康码事件
      this.$parent.$emit('onHealthInfoClose')
    }
  }
}
</script>

<style scoped lang="less">
.hesuan {
  margin-top: 0.2rem;
  padding: 0.1rem;
  border-radius: 10px;
  color: white;
}

.hesuanBorder {
  border-radius: 10px;
  padding: 0.3rem 0;
  border: 1px solid white;
}

.health-container {
  max-height: 13rem;
  overflow: auto;
}

// .loading-container {
//   height: 100vh;
//   width: 100%;
//   background: rgba(0, 0, 0, 0.6);
//   overflow: hidden;
//   position: fixed;
//   left: 0;
//   top: 0;
//   z-index: 999;

//   .loading {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translateY(-50%) translateX(-50%);
//   }
// }
</style>